// Generated by purs version 0.14.4
import * as Control_Monad_Cleanup from "../Control.Monad.Cleanup/index.js";
import * as Control_Monad_Reader_Trans from "../Control.Monad.Reader.Trans/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Effect from "../Effect/index.js";
var Slot = (function () {
    function Slot(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    };
    Slot.create = function (value0) {
        return function (value1) {
            return function (value2) {
                return new Slot(value0, value1, value2);
            };
        };
    };
    return Slot;
})();
var replaceSlot = function (v) {
    return v.value0;
};
var newSlot = function (dict) {
    return dict.newSlot;
};
var destroySlot = function (v) {
    return v.value1;
};
var appendSlot = function (v) {
    return v.value2;
};
var monadReplaceReaderT = function (dictMonadReplace) {
    return {
        newSlot: (function () {
            var slotWith = function (env) {
                return function (slot) {
                    return new Slot(function (m) {
                        return replaceSlot(slot)(Control_Monad_Reader_Trans.runReaderT(m)(env));
                    }, destroySlot(slot), Data_Functor.map(Effect.functorEffect)(slotWith(env))(appendSlot(slot)));
                };
            };
            return Control_Monad_Reader_Trans.ReaderT(function (env) {
                return Data_Functor.map(((((dictMonadReplace.MonadCleanup1()).Monad0()).Bind1()).Apply0()).Functor0())(slotWith(env))(newSlot(dictMonadReplace));
            });
        })(),
        Monad0: function () {
            return Control_Monad_Reader_Trans.monadReaderT((dictMonadReplace.MonadCleanup1()).Monad0());
        },
        MonadCleanup1: function () {
            return Control_Monad_Cleanup.monadCleanupReaderT(dictMonadReplace.MonadCleanup1());
        }
    };
};
export {
    newSlot,
    Slot,
    replaceSlot,
    destroySlot,
    appendSlot,
    monadReplaceReaderT
};
//# sourceMappingURL=index.js.map
